<template>
    <div>
		<!-- 进度条 -->
		<div 
			class="progressBar" 
			v-if="quanxian && quanxian.showSchedule == 1" 
			:style="{ width: `${percentage}%` }"></div>
        <NoticePage v-if="isShowNotice" :notice="notice" :title="data.title" @answerSubmitClick="answerSubmitClick" :isPc="false"></NoticePage>
        
        <div
         v-else-if="!isShowNotice" class="content" ref="content" 
            :style="{ 
                backgroundColor: bandingstyle.appearancePhone.bgColor,
                backgroundImage: `url(${bandingstyle.appearancePhone.bgImg})`,
                backgroundRepeat: bandingstyle.appearancePhone.bgLocation
            }" 
        >
            <div class="body-box">
                <div class="answer-sheet-box"><p @click="drawer = true"><i class="el-icon-s-grid"></i>答题卡</p></div>
                <div class="body"
                    :style="{
                    backgroundColor: `rgba(255,255,255,${bandingstyle.appearancePhone.bgOpacity / 100})`}"
                >
                    <div class="pageHeader" 
                        v-if="bandingstyle.appearancePhone.headerState == 1"
                        >
                        <div 
                            class="pageHeaderText" 
                            :style="{backgroundColor: bandingstyle.appearancePhone.headerBgcolor}" 
                            v-if="bandingstyle.appearancePhone.headerType == 0" >
                            <div 
                                :style="{
                                    fontSize: bandingstyle.appearancePhone.titleSize+'px',
                                    color:bandingstyle.appearancePhone.headerColor,
                                    fontWeight: bandingstyle.appearancePhone.headerBold,
                                    fontStyle: bandingstyle.appearancePhone.headerItalic,
                                    textDecoration: bandingstyle.appearancePhone.headerUnderline,
                                    textAlign: bandingstyle.appearancePhone.headerAlign
                                    }"
                            >
                                {{bandingstyle.appearancePhone.headerContent}}
                            </div>
                        </div>
                        
                        <div v-else-if="bandingstyle.appearancePhone.headerType == 1">
                            <img
                            style="width: 100%; height: auto"
                            :src="bandingstyle.appearancePhone.headerImg">
                        </div>
                    </div>
                    <div class="logo"
                        v-if="bandingstyle.appearancePhone.logoSet"
                        :style="{textAlign: bandingstyle.appearancePhone.logoLocation}"
                        >
                        <img class="logo-img" :src="bandingstyle.appearancePhone.logoSet">
                    </div>
                    <div class="ques_box"
                        :class="{'paddingT': bandingstyle.appearancePhone.logoSet && bandingstyle.appearancePhone.headerState == 0}"
                    >
                        <div class="header">
                            <p class="title"
                            v-if="bandingstyle.appearancePhone.displayTitle != 0"
                            :style="{
                                fontSize: bandingstyle.appearancePhone.fontTitleSize+'px',
                                color:bandingstyle.appearancePhone.fontTitleColor,
                                fontWeight: bandingstyle.appearancePhone.fontTitleBold,
                                fontStyle: bandingstyle.appearancePhone.fontTitleItalic,
                                textDecoration: bandingstyle.appearancePhone.fontTitleUnderline
                            }"
                            v-html="data.title"
                            ></p>
                            <p class="welcome-words"
                                v-if="bandingstyle.appearancePhone.displayWelcome != 0"
                                :style="{
                                    fontSize: bandingstyle.appearancePhone.fontWelcomeSize+'px',
                                    color:bandingstyle.appearancePhone.fontWelcomeColor,
                                    fontWeight: bandingstyle.appearancePhone.fontWelcomeBold,
                                    fontStyle: bandingstyle.appearancePhone.fontWelcomeItalic,
                                    textDecoration: bandingstyle.appearancePhone.fontWelcomeUnderline
                                }"
                                v-html="data.depict"
                                ></p>
                            <div class="info" v-if="quanxian">
                                <p class="info_num"><span>共{{data.quesCount}}题</span><span>共{{data.totalScore}}分</span></p>
                                <span v-show="quanxian.openReverseTimeStatus == 1" class="itemC">倒计时：
                                    <CountDown ref="countDown" :endTime="endTime" :endText="'结束了'" @examendChange="examendChange"></CountDown>
                                </span>
                                <!-- <div class="progress_box" v-if="quanxian.showSchedule == 1">
                                    <span>进度条：</span>
                                    <el-progress class="progress" :percentage="percentage" :color="customColor"></el-progress>
                                </div> -->
                            </div>
                        </div>
                        <template v-if="list.length > 0">
                            <div  v-for="(item, index) in list" :key="index">
                                <!-- 基本信息 -->
                                <div :name="`name${item.qid}`" v-if="item.questionsTypeId == 600 && item.isHideTitle == false" class="basic_info ques_list">
                                    <div class="ques_list_item">
                                        <p class="title" 
                                            :class="{'required':item.mustanswer}"
                                            :style="{
                                                fontSize: bandingstyle.appearancePhone.fontStemSize+'px',
                                                color:bandingstyle.appearancePhone.fontStemColor,
                                                fontWeight: bandingstyle.appearancePhone.fontStemBold,
                                                fontStyle: bandingstyle.appearancePhone.fontStemItalic,
                                                textDecoration: bandingstyle.appearancePhone.fontStemUnderline
                                            }"
                                        >
                                            <span v-html="item.questionsName"></span>
                                        </p>
                                        <div class="input_box">
                                            <el-input
                                                :class="{'input__err': item.validate}"
                                                class="input" v-model="item.userAnswer" 
                                                type="textarea"
                                                resize="none"
                                                :rows="item.inputHeight == '小' ? 1 : (item.inputHeight == '中' ? 2 : 3)"
                                            ></el-input>
                                            <div v-show="item.validate" class="form-item__error">{{item.validateMsg}}</div>
                                        </div>
                                    </div>
                                </div>
                                <!-- 单选题 -->
                                <SelectTypeTM 
                                    v-else-if="item.questionsTypeId == 100 
                                    || item.questionsTypeId == 101 
                                    || item.questionsTypeId == 102"
                                    :data="item"
                                    :bandingstyle="bandingstyle"
                                    :showTitleNum="quanxian ? quanxian.showTitleNum : 1"
                                    @userAnswerChange="userAnswerChange"
                                ></SelectTypeTM>
                                <ShortAnswerTM
                                    v-else-if="item.questionsTypeId == 204 
                                    || item.questionsTypeId == 206
                                    || item.questionsTypeId == 207
                                    || item.questionsTypeId == 208"
                                    :data="item"
                                    :bandingstyle="bandingstyle"
                                    :showTitleNum="quanxian ? quanxian.showTitleNum : 1"
                                ></ShortAnswerTM>
                                
                                <!-- 绘图 -->
                                <div :name="`name${item.qid}`" v-if="item.questionsTypeId == 209" class="basic_info ques_list">
                                    <div class=" ques_list_item">
                                        <div class="title" 
                                            :class="{'required':item.mustanswer}"
                                            :style="{
                                                fontSize: bandingstyle.appearancePhone.fontStemSize+'px',
                                                color:bandingstyle.appearancePhone.fontStemColor,
                                                fontWeight: bandingstyle.appearancePhone.fontStemBold,
                                                fontStyle: bandingstyle.appearancePhone.fontStemItalic,
                                                textDecoration: bandingstyle.appearancePhone.fontStemUnderline
                                            }"
                                        >
                                            <span v-if="quanxian ? quanxian.showTitleNum : 1">{{item.quesIndex + 1}}、</span><p v-html="item.questionsName"></p>
                                        </div>
                                        <div class="input_box">
                                            <div id="signature" class="signature">
                                                <canvas v-show="!item.userAnswer" :class="`canvasId${item.qid}`"/>
                                                <img v-show="item.userAnswer" :src="item.userAnswer" alt="">
                                                <div class="save-signature">
                                                    <span>完成签名后，请点击【完成】按钮</span>
                                                    <div >
                                                        <el-button size="mini"  v-show="!item.userAnswer" @click="saveCanvasId(item)">完成</el-button>
                                                        <el-button size="mini" v-show="item.userAnswer" @click="clearCanvasId(item)">清除</el-button>
                                                    </div>

                                                </div>
                                            </div>
                                            <div v-show="item.validate" class="form-item__error">{{item.validateMsg}}</div>
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- 上传文件 -->
                                <div :name="`name${item.qid}`" v-if="item.questionsTypeId == 210" class="basic_info ques_list">
                                    <div class=" ques_list_item">
                                        <div class="title" 
                                            :class="{'required':item.mustanswer}"
                                            :style="{
                                                fontSize: bandingstyle.appearancePhone.fontStemSize+'px',
                                                color:bandingstyle.appearancePhone.fontStemColor,
                                                fontWeight: bandingstyle.appearancePhone.fontStemBold,
                                                fontStyle: bandingstyle.appearancePhone.fontStemItalic,
                                                textDecoration: bandingstyle.appearancePhone.fontStemUnderline
                                            }"
                                        >
                                            <span v-if="quanxian ? quanxian.showTitleNum : 1">{{item.quesIndex + 1}}、</span><p v-html="item.questionsName"></p>
                                        </div>
                                        <div class="input_box">
                                            <el-upload
                                                class="upload-demo upload-demo-file"
                                                :accept="item.limitFormat"
                                                :action="$config.service.uploadApi"
                                                :on-success="(response, file, fileList)=> handleSuccess(response, file, fileList, item)"
                                                :before-upload="(file)=> beforeAvatarUpload(file, item)"
                                                :data="QiniuData"
                                                :on-remove="(file, fileList)=> handleRemove(file, fileList, item)"
                                                :on-exceed="(file, fileList) => handleExceed(file, fileList, item)"
                                                :limit="parseInt(item.maxfilesNum)"
                                                :file-list="item.fileList"
                                                :multiple="item.maxfilesNum == 1 ? false : true">
                                                <div class="el-upload__text">选择文件</div>
                                                <div class="el-upload__tip">最多{{item.maxfilesNum}}个，单个文件大小不超过{{item.fileSize}}MB</div>
                                            </el-upload>     
                                            <div v-show="item.validate" class="form-item__error">{{item.validateMsg}}</div>
                                        </div>
                                    </div>
                                </div>

                                <!-- 段落描述 -->
                                <div :name="`name${item.qid}`"
                                    v-else-if="item.questionsTypeId == 401" 
                                    class="test_question list"
                                    :style="{
                                        fontSize: bandingstyle.appearancePhone.fontStemSize+'px',
                                        color:bandingstyle.appearancePhone.fontStemColor,
                                        fontWeight: bandingstyle.appearancePhone.fontStemBold,
                                        fontStyle: bandingstyle.appearancePhone.fontStemItalic,
                                        textDecoration: bandingstyle.appearancePhone.fontStemUnderline
                                    }"
                                >
                                    <p class="title" v-html="item.questionsName"></p>
                                </div>
                            </div>
                        </template>
                        <div class="no-more" v-else-if="list.length == 0">
                            这里什么也没有~
                        </div>
                        <div class="btn-box">
                            <el-button class="btn" size="medium" v-if="page != 1" @click="lastPage">上一页</el-button>
                            <el-button class="btn" size="medium" v-if="page != lists.length" @click="nextPage">下一页</el-button>
                            <el-button class="btn" size="medium" type="primary" @click="submit" v-if="page == lists.length && !isBank" :disabled="list.length == 0">
                                {{bandingstyle.appearancePhone.buttonContent ? bandingstyle.appearancePhone.buttonContent : '提交'}}
                            </el-button>
                        </div>
                        <div class="report-box">
                            <!-- <span class="report">举报</span> -->
                        </div>
                    </div>
                    
                    
                </div>
            </div>
            <el-drawer
                class="drawer"
                :modal-append-to-body="false"
                title="答题卡"
                :visible.sync="drawer"
                :direction="direction">
                <div class="clearfix footer-box itemC">
                    <span class="sign1 itemC">已答 {{answeredNum}}</span>
                    <span class="sign2 itemC">未答 {{unansweredNum}}</span>
                </div>
                <div class="body">
                    <template v-for="(item, index) in data.questionsList">
                        <div class="item_list" 
                            v-if="item.questionsTypeId != 402 && item.questionsTypeId != 404"
                            :id="`answer-sheet${item.oid}`"
                            :class="{
                                'selected': (item.userAnswer && item.userAnswer) || 
                                (item.userAnswerArr && item.userAnswerArr.length > 0)
                                }"
                            @click="goAnchor(`name${item.qid}`, item.qid)" :key="index">
                            {{item.quesIndex || item.quesIndex == 0 ? item.quesIndex + 1 : ''}}
                        </div>
                    </template>
                    
                </div>
            </el-drawer>
        </div>
    </div>
</template>

<script>
import CountDown from '@/components/countDown'
import SelectTypeTM from './selectTypeTM.vue'
import ShortAnswerTM from './shortAnswerTM.vue'
import SignaturePad from 'signature_pad';
import NoticePage from './noticePage.vue';
import { v1 as UUID } from "uuid";
import { mapState } from "vuex"
import { Check } from '@/util/checkValue/CheckValue.js';
export default {
    components: {
        SelectTypeTM,
        ShortAnswerTM,
        CountDown,
        NoticePage
    },
    name: 'appearanceTM',
    props: {
        bandingstyle:{},
        data: {},
        quanxian: {},
        isBank: {
            type: Boolean,
            default: false // true 题库预览
        },
    },
    data() {
        return {
            customColor: '#50E6A7',
            input: '',
            radio: '',
            checkList: [],
            textarea: '',
            exam: {},
            endTime: '',
            list: [],
            currentId: 40,
            lists: [],
            page: 1,
            drawer: false,
            direction: 'btt',
            activeQid: '',
            percentage: 0,
            QiniuData: {
				biz: 'upDataKs',
				data: {}
            },
            config:{
                penColor: "#000000",   //笔刷颜色
                minWidth: 1,       //最小宽度
                maxWidth: 3,
                backgroundColor: '#f7f8fa'
            },
            answeredNum: 0,
            unansweredNum: 0,
			isShowNotice: false,
			notice: {}
        }
    },
	computed: {
        ...mapState(['headers']),
	},
    watch:{
        activeQid(newV) {
            // console.log(newV)
            this.lists.forEach((info, index) => {
                info.forEach((item, i) => {
                    if (newV == item.qid) {
                        this.page = index + 1
                        this.list = info
                        // console.log(this.page)
                    }
                })
            })
        },
        'lists':{
            handler(newV, oldV) {
                let count = 0
                this.answeredNum = 0
                this.unansweredNum = 0
                if (this.data.questionsList){
                    
                    this.data.questionsList.forEach((info,index) => {
                        if(info.questionsTypeId != 401 && info.questionsTypeId != 402 && info.questionsTypeId != 404) {
                            count++
                            if(info.userAnswer && info.userAnswer != ''){
                                // console.log(info.userAnswer)
                                this.answeredNum++
                            }else if(info.userAnswerArr && info.userAnswerArr.length > 0){
                                this.answeredNum++
                            } else {
                                this.unansweredNum++
                            }
                        }
                    })
                    this.percentage = parseInt((this.answeredNum / count) * 100)
                    
                    if(this.quanxian && this.quanxian.saveLastContent == 1) {
                        localStorage.setItem(this.id, JSON.stringify(this.data.questionsList)) 
                    }
                }
            },
            deep: true,
            // immediate: true
        } 
    },
    created() {
        console.log(this.data)
        // sessionStorage.removeItem("examId")
        this.id = this.getQueryStringhash('id')
        // 权限start
        // 获取考试结束倒计时
        if (this.quanxian && this.quanxian.examEndStatus == 1) {
            this.endTime = parseInt(new Date(this.quanxian.examEndTime).getTime())
            this.endTime = this.endTime.toString()
        }
        // 权限end
        // console.log(this.data)
        // window.addEventListener('mousewheel', this.handleScroll,true)||window.addEventListener("DOMMouseScroll",this.handleScroll,false)
        let arr = []
        if (this.data.questionsList && this.data.questionsList.length > 0) {
			this.data.questionsList = this.data.questionsList.filter((info, index) => {
				if (info.questionsTypeId == 600) {
					if (!info.userAnswer) {
						info.userAnswer = info.placeholder;
					}
				} else if (info.questionsTypeId == 501) {
					// 考前须知
					this.isShowNotice = true
					this.notice = info
				}
				if (info.questionsTypeId == 402 || info.questionsTypeId == 404) {
					this.lists.push(arr);
					arr = [];
				} else {
					arr.push(info);
				}
				if (index == this.data.questionsList.length - 1) {
					this.lists.push(arr);
				}
				return info.questionsTypeId != 501
			});
			console.log(this.data.questionsList)
			console.log(this.lists)
			this.lists = this.lists.filter((info) => {
				
				return info.length > 0
			})
			this.list = this.lists[0];
			if (!this.isShowNotice) {
				this.list.forEach(info => {
					if (info.questionsTypeId == 209) {
						this.$nextTick(() => {
							this.getCanvas(info.qid, info);
						});
					}
				});
			}
		}
    },
    mounted() {
    },
    methods:{
		changeCountDown(){
			this.$refs.countDown.stopCountDown()
		},
        answerSubmitClick() {
            this.isShowNotice = false
            this.list.forEach(info => {
				if (info.questionsTypeId == 209) {
					this.$nextTick(() => {
						this.getCanvas(info.qid, info);
					});
				}
			});
        },
        // 当试题存在逻辑，用户答题后触发
		userAnswerChange(data) {
			// 选项关联 试题是否显示
			this.displayLogic(data);
		},
		displayLogic(data) {
			let { questionsList } = this.data;
			for (let j = 0; j < questionsList.length; j++) {
				// 选项关联
				if (data.associated && data.associated.indexOf(questionsList[j].qid) !== -1) {
					
					// 获取当前试题已选的option
					let newOptionList = this.getOption(data);
					let copiedNewOptionList = newOptionList.map(option => ({ ...option }));
					// 保留不是当前试题的option
					let actionOptionList = questionsList[j].optionList.filter(info => data.qid != info.qid);
					questionsList[j].optionList = [...copiedNewOptionList, ...actionOptionList];

					// 如果被关联的试题 已答并选项被清除 清除答案
					this.clearAnswer(questionsList[j]);
				}
			}
		},
		
		// 获取该题已选的option
		getOption(data) {
			return data.optionList.filter(op => {
				if (data.userAnswer && data.userAnswer == op.oid) {
					op.qid = data.qid;
					op.inputValue = '';
					return op;
				}
				if (data.userAnswerArr && data.userAnswerArr.indexOf(op.oid) !== -1) {
					op.qid = data.qid;
					op.inputValue = '';
					return op;
				}
			});
		},
		
		// 被关联的试题 清除answer
		clearAnswer(question) {
			if (question.userAnswerArr) {
				let oidArr = question.optionList.map(val => val.oid);
				let i = question.userAnswerArr.findIndex(val => oidArr.indexOf(val) == -1);
				if (i !== -1) question.userAnswerArr.splice(i, 1);
			}
			if (question.userAnswer) {
				let i = question.optionList.findIndex(val => question.userAnswer == val.oid);
				// console.log(i)
				if (i === -1) question.userAnswer = '';
			}
		},
		beforeAvatarUpload(file, item) {
			let size = file.size < 1024 * 1024 * item.fileSize;
			if (!size) {
                item.validate = true
                item.validateMsg = `上传文件大小不能超过 ${item.fileSize}MB，请重新选择文件！`
				return size;
			} else if (!isFormatValid) {
                item.validate = true
                item.validateMsg = `文件格式不正确！仅支持 ${item.limitFormat} 格式，请重新选择文件！`
				return isFormatValid;
			} else {
                item.validate = false
                item.validateMsg = ''
				this.QiniuData.data = file;
			}
		},
		handleSuccess(res, file, fileList, item) {
			if (typeof item.userAnswerArr == 'string') {
				item.userAnswerArr = []
			}
			item.userAnswerArr.push(res.message);
			item.fileList = fileList;
		},
		handleRemove(file, fileList, item) {
			if (file.status != 'success') return
			item.userAnswerArr = [];
			fileList.forEach(info => {
				item.userAnswerArr.push(info.response.message);
			});
			item.fileList = fileList;
		},
		handleExceed(file, fileList, item) {
			if (file.length > item.maxfilesNum || fileList.length === item.maxfilesNum) {
                item.validate = true
                item.validateMsg = `最多只允许上传${item.maxfilesNum}个文件`
			} else {
                item.validate = false
                item.validateMsg = ''
            }
		},
        getCanvas(qid, info) {
            let div = document.getElementById("signature");
            var w = div.offsetWidth;  
            var canvas = document.querySelector(`.canvasId${qid}`);
            info.signaturePad = new SignaturePad(canvas, this.config);
            canvas.height = 190;
            canvas.width = w
        },
        saveCanvasId(item) {
            if (item.signaturePad.isEmpty() == false) {
                item.userAnswer = item.signaturePad.toDataURL()
            } else {
                item.userAnswer = ''
            }
        },
        clearCanvasId(item) {
            item.signaturePad.clear()
            item.userAnswer = ''
        },
        lastPage() {
            if (this.page > 1) {
                this.page --
                this.list = this.lists[this.page - 1]
                if(this.list.length > 0) {
                    this.list.forEach(info => {
                        if (info.questionsTypeId == 209) {
                            this.$nextTick(() =>{
                                this.getCanvas(info.qid, info)
                            })
                        }
                    }) 
                }
                this.scrollToTop()
            }
        },
		scrollToTop() {
			document.documentElement.scrollTop = 0
			document.body.scrollTop = 0
		},
		verification() {
			let result = false;
			for (let i in this.list) {
				let otherArr = [ 100, 101, 102 ]
				if (otherArr.indexOf(this.list[i].questionsTypeId) != -1) {
					for(let j in this.list[i].optionList) {
						if (this.list[i].optionList[j].notAnswer && this.list[i].optionList[j].inputValue == ''){
							continue;
						}
						console.log('this.list[i].optionList[j] :>> ', this.list[i].optionList[j]);
						if (this.list[i].optionList[j].format || this.list[i].optionList[j].haveInput) {
							if (((this.list[i].questionsTypeId == 100 || this.list[i].questionsTypeId == 102) && this.list[i].userAnswer == this.list[i].optionList[j].oid)||
								this.list[i].questionsTypeId == 101 && this.list[i].userAnswerArr.indexOf(this.list[i].optionList[j].oid) != -1
							) {
								console.log('this.list[i].questionsTypeId', this.list[i].questionsTypeId)
								this.list[i].optionList[j].userAnswer = this.list[i].optionList[j].inputValue
								result = Check(this.list[i].optionList[j],this.list[i]);
								console.log('result :>> ', result);
								if (result) {
									this.goAnchor(`name${this.list[i].qid}`, this.list[i].qid);
									return result;
								}
							}
						}
					}
				}
				if (this.list[i].mustanswer) {
					if (this.list[i].questionsTypeId == 101 || this.list[i].questionsTypeId == 210) {
						if (this.list[i].userAnswerArr.length == 0) {
							this.list[i].validate = true;
							this.goAnchor(`name${this.list[i].qid}`, this.list[i].qid);
							return (result = true);
						} else {
							this.list[i].validate = false;
						}
					} else if (this.list[i].questionsTypeId == 207 || this.list[i].questionsTypeId == 208) {
                        this.list[i].optionList.forEach((info) => {
							info.validate = false
						})
						for (let j in this.list[i].optionList) {
							if (this.list[i].optionList[j].mustanswer) {
								if (!this.list[i].optionList[j].userAnswer) {
									this.list[i].optionList[j].validate = true;
									this.list[i].optionList[j].validateMsg = '请输入内容';
									this.goAnchor(`name${this.list[i].qid}`, this.list[i].qid);
									return (result = true);
								} else {
									result = Check(this.list[i].optionList[j]);
									if (result) {
										this.goAnchor(`name${this.list[i].qid}`, this.list[i].qid);
										return result;
									}
								}
							} else {
								if (this.list[i].optionList[j].userAnswer) {
									result = Check(this.list[i].optionList[j]);
									if (result) {
										this.goAnchor(`name${this.list[i].qid}`, this.list[i].qid);
										return result;
									}
								} else {
									this.list[i].optionList[j].validate = false;
								}
							}
						}
					} else if (this.list[i].questionsTypeId == 204 || this.list[i].questionsTypeId == 206 || this.list[i].questionsTypeId == 600) {
						if (this.list[i].userAnswer == '') {
							this.list[i].validate = true;
							this.list[i].validateMsg = '请输入内容';
							this.goAnchor(`name${this.list[i].qid}`, this.list[i].qid);
							return (result = true);
						} else {
							result = Check(this.list[i]);
							if (result) {
								this.goAnchor(`name${this.list[i].qid}`, this.list[i].qid);
								return result;
							}
						}
					} else if (this.list[i].questionsTypeId == 100 || this.list[i].questionsTypeId == 102 || this.list[i].questionsTypeId == 209) {
						if (this.list[i].userAnswer == '') {
							this.list[i].validate = true;
							this.goAnchor(`name${this.list[i].qid}`, this.list[i].qid);
							return (result = true);
						} else {
							this.list[i].validate = false;
						}
					}
				} else {
					if (this.list[i].questionsTypeId == 207 || this.list[i].questionsTypeId == 208) {
                        this.list[i].optionList.forEach((info) => {
							info.validate = false
						})
						for (let j in this.list[i].optionList) {
							if (this.list[i].optionList[j].userAnswer == '') {
								this.list[i].optionList[j].validate = true;
								this.goAnchor(`name${this.list[i].qid}`, this.list[i].qid);
								return (result = true);
							} else {
								result = Check(this.list[i].optionList[j]);
								if (result) {
									this.list[i].optionList[j].validate = true;
									this.goAnchor(`name${this.list[i].qid}`, this.list[i].qid);
									return true;
								}
							}
						}
					} else if (this.list[i].questionsTypeId == 204 || this.list[i].questionsTypeId == 206 || this.list[i].questionsTypeId == 600) {
						if (this.list[i].userAnswer != '') {
							result = Check(this.list[i]);
							if (result) {
								this.goAnchor(`name${this.list[i].qid}`, this.list[i].qid);
								this.list[i].validate = true;
								return result;
							}
						} else {
							this.list[i].validate = false;
							result = false;
						}
					}
				}
			}
			return result;
		},
        nextPage() {
            if (this.page < this.lists.length) {
                // 验证
                if (this.verification() == false) {
                    this.page ++
                    this.list = this.lists[this.page - 1]
                    if(this.list.length > 0) {
                        this.list.forEach(info => {
                            if (info.questionsTypeId == 209) {
                                this.$nextTick(() =>{
                                    this.getCanvas(info.qid, info)
                                })
                            }
                        }) 
                    }
					this.scrollToTop()
                }
            }
        },
        submit() {
            // console.log('提交')
            let aaa = this.verification()
            // console.log(aaa)
            // console.log(this.data.questionsList)
            // 验证
            if (this.verification() == false) {
                this.$emit('submit')
            }
        },
        
        // 获取参数 带#
        getQueryStringhash(key) {
            let after = window.location.hash.split("?")[1];
            if (after) {
                let reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
                let r = after.match(reg);
                if (r != null) {
                    return decodeURIComponent(r[2]);
                }
                else {
                    return null;
                }
            }
        },
        // handleScroll(e) {
        //     let direction = e.deltaY > 0 ? 'down' : 'up'
        //     if( this.currentId >= 0 && direction == 'down') {
        //         this.currentId = this.currentId + 40
        //     } else if(this.currentId > 0 && direction == 'up'){
        //         this.currentId = this.currentId - 40
        //     }
        //     this.$refs.content.scrollTo(0, this.currentId)
        // },
        goAnchor(aname, qid) {
            this.activeQid = qid
            let selector = `div[name=${aname}]`;
            var anchor = this.$el.querySelector(selector); //获取元素
            // console.log(anchor)
            if (anchor) {
                // start
                anchor.scrollIntoView({ block: "center", behavior: "smooth" });
                // anchor.scrollIntoView();
            }
            this.drawer = false
        },
        examendChange() {
            // console.log('考试结束了')
            this.examEnded = true
            // 是否开启考试结束后n没有新操作就强制交卷
            if(this.quanxian.overtimeForceSubmit == 1 && this.examEnded == true) {
                this.$emit('addEventListener', 1)
            }
        },
    },

}
</script>
<style lang="scss" scoped>
.progressBar{
	height: 3px;
	background-color: #0080FF;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 9999;
}
.test_question{
    .title{
        word-break: break-all;
        display: flex;
    }
}
.content::-webkit-scrollbar{
    display: none;
}
.content{
	// 给固定高度在微信浏览器会出现软键盘隐藏会出现空白
    // height: 721px;
    // border-radius: 20px;
    width: 100% !important;
    overflow-y:auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    overflow-x: hidden;
	background-attachment: fixed;
    background-size: cover;
    .body-box::-webkit-scrollbar{
        width: 0;
    }
    .body-box{
        overflow-y: auto;
        // height: 721px;
        // padding: .28rem .10rem 0 .10rem;
        padding: 28px 10px 0 10px;
        box-sizing: border-box;
        .answer-sheet-box{
            // font-size: 0.14rem;
            font-size: 14px;
            line-height: 40px;
            text-align: end;
        }
        .body{
            position: relative;
            width: 100%;
        .logo{
            position: absolute;
            top: 20px;
            right: 0;
            left: 0;
            bottom: 0;
            z-index: 1000;
            padding:0 10px;
            box-sizing: border-box;
            height: fit-content;
            .logo-img{
                display: inline;
                max-height: 60px;
                max-width: 100%;
            }
        }
        
        .ques_box{
            padding: 0px 10px 50px 10px;
            box-sizing: border-box;
            width: 100%;
            font-style: normal;
            font-size: 16px;
            .header{
                font-size: 20px;
                padding-top: 20px;
                .title{
                    text-align: center;
                }
                .welcome-words{
                    font-size: 16px;
                    color: #666666;
                    margin-top: 20px;
                }
            }
            .list{
                padding-top: 40px;
            }
            .ques_list{
                .ques_list_item{
                    margin-top: 28px;
                }
                .title{
                    // width: 100px;
                    margin-bottom: 10px;
                    word-break: break-all;
                    display:flex;
                }
                // .input {
                //     width: 220px;
                // }
            }
            
            
        }
    }
    .pageHeaderText{
        background-color: #EFF4FE;
        text-align: left;
        font-size: 16px;
        color: #666666;
        padding: 10px 18px
    }
    }
    
}
.required::before{
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
}
.selected{
    border: 1px solid #bae4f6 !important;
    background: #e8fbff;
    color: #2196f3;
}
.itemC{
    display: flex;
    align-items: center;
}
.btn-box{
    text-align: center;
    margin-top: 20px;
    .btn{
        width: 100%;
    }
    /deep/.el-button+.el-button {
        margin-left: 0;
        margin-top: 10px;
    }
}
.report-box{
    font-size: 12px;
    color: #707070;
    margin-top: 10px;
    text-align: right;
    .report{
        display: inline-block;
    }
}
.paddingT{
   padding-top: 80px !important;
}
.no-more{
    font-size: 16px;
    color: #a1a1a1;
    margin-bottom: 20px;
    text-align: center;
}
.drawer{
    /deep/.el-drawer__header{
        // font-size: 1rem;
        font-size: 16px;
    }
    /deep/.el-drawer{
        height: 42% !important;
        border-radius: 12px 12px 0 0;
    }
    .body {
        padding: 12px 20px;
        display: flex;
        flex-wrap: wrap;
        .item_list{
            margin: 4px 2px;
            font-size: 12px;
            line-height: 39px;
            text-align: center;
            width: 39px;
            height: 39px;
            border-radius: 50%;
            border: 1px solid #ccc;
            cursor: pointer;
        }
    }

    .footer-box{
        padding: 12px 20px;
        // border-bottom: 1px solid #EBEEF5;
        box-sizing: border-box;
        font-size: 12px;
        .sign1{
            margin-right: 20px;
        }
        .sign1::before {
            content: '';
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            border: 1px solid rgb(186, 228, 246);
            background: rgb(232, 251, 255);
            margin-right: 5px;
        }
        .sign2::before {
            content: '';
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            border: 1px solid #ccc;
            background: #fff;
            margin-right: 5px;
        }
    }
}
.asda{
    height: 200px;
    background-color: #f56c6c;
    position: fixed;
    bottom: 100px;
}
.info{
    display: flex;
    flex-direction: column;
    align-items: center;
    font-weight: 100;
    font-size: 14px;
    margin-top: 20px;
    .progress_box{
        display: flex;
        align-items: center;
        margin-left: 20px;
        .progress{
            width: 150px;
        }
    }
}
.upload-demo-file{
    margin-top: 10px;
}
/deep/.el-upload--text{
    padding: 9px 18px;
    border: 1px solid #dde5ed;
    border-radius: 2px;
    text-align: center;
    font-size: 14px;
    color: #aaa;
    line-height: 14px;
    width: 100%;
    box-sizing: border-box;
}
</style>
<style lang="scss">
.input_box{
    position: relative;
    .signature{
        width: 100%;
        border: 1px solid rgba(0,0,0,.1);
        margin: 20px 0;
    .save-signature{
        width: 100%;
        height: 40px;
        line-height: 40px;
        background: #fff;
        border-top: 1px solid rgba(0,0,0,.1);
        color: #aaa;
        font-size: 12px;
        padding: 0 10px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
    }
    }
    .form-item__error{
        color: #f56c6c;
        font-size: 12px;
        line-height: 1;
        padding-top: 4px;
        position: absolute;
        // top: 92px;
        // left: 228px;
    }
    /deep/.input__err .el-input__inner{
        border-color: #f56c6c;
    }
}
</style>